// extracted by mini-css-extract-plugin
module.exports = {"footerPayments":"Payments_footer-payments__X6w4L","footerPaymentsImage":"Payments_footer-payments-image__uKH1B"};